import './Shift.css';

import { IntlProvider, addLocaleData } from 'react-intl';
import React, { Fragment } from 'react';

import ErrorBoundary from 'react-error-boundary';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import Router from '../../views/Router';
import UnknownError from '../../../components/views/UnknownError';
import en from 'react-intl/locale-data/en';
import fr from 'react-intl/locale-data/fr';
import { matchPath } from 'react-router-dom';
import messages from '../../../translations/translations';

addLocaleData([...en, ...fr]);
const localeMatch = '/:locale([a-z]{2}-[A-Z]{2})';
const Shift = ({ location, history }) => {
  // below is necessary because IntlProvider is a parent of the route that contains the locale. Thus we need to manually get the locale parameter from our location, duplicating the functionality that comes from the router
  const match = matchPath(location.pathname, `${localeMatch}`);
  const locale = match ? match.params.locale : 'en-CA';
  window.onerror = function(message, filename, lineno, colno, error) {
    console.log(error)
    console.log(message)
    // history.push(`/${locale}/unknown-error`);
    return true;
  };
  return (
    <IntlProvider locale={locale} key={locale} messages={messages[locale]}>
      <ErrorBoundary FallbackComponent={UnknownError}>
        <Fragment>
          <Helmet
            htmlAttributes={{
              lang: locale
            }}
          >
            <title>FUSE</title>
          </Helmet>
          <Router location={location} />
        </Fragment>
      </ErrorBoundary>
    </IntlProvider>
  );
};
Shift.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object
};
export default Shift;



// WEBPACK FOOTER //
// ./src/components/container/Shift/index.js